// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ConfirmationModal from "../../ConfirmationModal.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function ApproveConfirmationModal(Props) {
  var isOpen = Props.isOpen;
  var start_date = Props.start_date;
  var onConfirmCb = Props.onConfirmCb;
  var onCancelCb = Props.onCancelCb;
  return React.createElement(ConfirmationModal.make, {
              title: "Update Start Date",
              isOpen: isOpen,
              onConfirmCb: onConfirmCb,
              onCancelCb: onCancelCb,
              confirm_button_title: "Yes, Approve",
              cancel_button_title: "No, Cancel",
              children: React.createElement("p", undefined, "This modification was scheduled to go live on " + (Timestamp$Catalyst.toString(start_date, "DD/MM/yyyy") + (". If Approved, it will now be effective from tomorrow " + Timestamp$Catalyst.toString(Timestamp$Catalyst.tomorrow(undefined), "DD/MM/yyyy"))))
            });
}

var make = ApproveConfirmationModal;

export {
  make ,
  
}
/* react Not a pure module */
